module.exports = __webpack_public_path__ + "static/media/github-repo-forked.0e48988e.svg";